import { createFileRoute } from '@tanstack/react-router';
import AngelRuz from '@/pages/AngelRuz';
import { buildBreadcrumb, ldJson } from '@/lib/site-schema';

const url = 'https://agenciaseoevolution.com/angel-ruz';
const title = 'Ángel Ruz: trayectoria, SEO e inteligencia artificial | SEOEVOLUTION';
const description = 'Conoce a Ángel Ruz Serrano, fundador de SEOEVOLUTION: desarrollo web, comercio electrónico, consultoría SEO y autoría de las guías de Conocimiento.';

export const Route = createFileRoute('/angel-ruz')({
  head: () => ({
    meta: [
      { title }, { name: 'description', content: description },
      { property: 'og:title', content: title }, { property: 'og:description', content: description },
      { property: 'og:type', content: 'profile' }, { property: 'og:url', content: url },
      { name: 'twitter:card', content: 'summary' },
      { name: 'twitter:title', content: title }, { name: 'twitter:description', content: description },
    ],
    links: [{ rel: 'canonical', href: url }],
    scripts: [ldJson({
      '@context': 'https://schema.org', '@type': 'ProfilePage',
      '@id': `${url}#profile`, url, name: title, description, dateModified: '2026-11-05',
      mainEntity: {
        '@type': 'Person', '@id': `${url}#person`, name: 'Ángel Ruz Serrano', alternateName: 'Ángel Ruz',
        url, sameAs: ['https://angelruz.com/'], jobTitle: 'Fundador y director de proyectos',
        worksFor: { '@type': 'Organization', name: 'SEOEVOLUTION', url: 'https://agenciaseoevolution.com' },
        knowsAbout: ['SEO', 'Desarrollo web', 'Comercio electrónico', 'SEO local', 'Visibilidad en respuestas de IA'],
      },
    }), ldJson(buildBreadcrumb([{ name: 'Ángel Ruz', path: '/angel-ruz' }]))],
  }),
  component: AngelRuz,
});